import {
   LIST_BANK_FEES,
   CHANGE_VALUES_FORM_FEE,
   SAVE_FORM_FEE,
   GET_ITEM_BANK_FEE,
   DELETE_ITEM_BANK_FEE,
   UPLOAD_LOGO_BANK_FEE,
   BANK_FEE_DEFAULT_DATA
} from '../constants/bank_fee';

export const bank_fees = ( state = {}, action ) => {
   switch ( action.type ) { 

      case LIST_BANK_FEES : {
         return action.payload;
      }

      case CHANGE_VALUES_FORM_FEE : {
         return action.payload;
      }

      case SAVE_FORM_FEE : {
         return action.payload;
      }

      case GET_ITEM_BANK_FEE : {
         return action.payload;
      }

      case DELETE_ITEM_BANK_FEE : {
         return action.payload;
      }

      case UPLOAD_LOGO_BANK_FEE : {
         return action.payload;
      }

      case BANK_FEE_DEFAULT_DATA : {
         return action.payload;
      }
 
     default :
     return state;
   }
}


